import { Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs';
import { LanguageCode } from '../models/language-code';

export function languageChangeSignal(
    translateService: TranslateService
): Signal<LanguageCode> {
    return toSignal(
        translateService.onLangChange.pipe(
            map((event) => event.lang as LanguageCode)
        ),
        { initialValue: translateService.getCurrentLang() as LanguageCode }
    );
}
